

























import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({ name: "ui-table-header-item" })
export default class UiTableMyHeaderItemComponent extends Vue {
  @Prop({ type: Object })                 styleCustom: Object;
  @Prop({ type: String })                    sortName: String;
  @Prop({ default: null, type: String })  defaultSort: String;

  styleObject = {
    //не работает вроде
    color: "red",
    fontSize: "13px",
    cursor: this.sortName ? "default" : "pointer"
  };
  sortType =
    this.defaultSort === null ? null : this.defaultSort === "asc" ? 0 : 1;

  created() {
    this.sortExecute(false)
  }
  sortExecute(value=true) {
    // debugger
    if (!this.sortName) return;
    if (this.sortType === null && !value) return;
    if (this.sortType === null ) this.sortType = 0;
    else if (this.sortType === 0) this.sortType = 1;
    else if (this.sortType === 1) this.sortType = 0;
    this.$emit("onSort", this.sortName,this.sortType);
  
  }
  checkedDesc() {
    return "desc" == this.defaultSort;
  }
  checkedAsc() {
    return "asc" == this.defaultSort;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-table/src/ui-table-header-item.vue